import { Injectable } from '@angular/core';
import { environment } from '../../../../environments/environment';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { CookieService } from 'ngx-cookie-service';
import { Observable } from 'rxjs';

export enum TypesMatrizEnum{
  THREATS = 'AMENAZA',
  OPPORTUNITIES = 'OPORTUNIDAD',
  WEAKNESSES = 'DEBILIDAD',
  STRENGTHS = 'FORTALEZA'
}

export class Matriz_FLOA {
  public type?: string;
  public name?: string;
  public perspectiveId?: number;
}
@Injectable({
  providedIn: 'root'
})
export class MatrizService {
  private apiURL = environment.apiURL_institucion;
  private headers = new HttpHeaders().append('Content-Type', 'application/json')
    .append('Authorization', 'Bearer ' + localStorage.getItem('token'));

  constructor(
    private http: HttpClient,
    private cookies: CookieService,
  ) { }

  public getFLOA(): Observable<any> {
      const apiURL = `${this.apiURL}matriz`;
    return this.http.get(`${apiURL}`, { headers: this.headers });
  }

  public postFLOA(floa: any): Observable<any> {
    const matrizz: Matriz_FLOA = {
      type: floa.tipo,
      name: floa.nombre,
      perspectiveId: Number(floa.perspectiveId),
    }
    const body = JSON.stringify(matrizz);
    const apiURL = `${this.apiURL}matriz`;
    return this.http.post(`${apiURL}`, body, { headers: this.headers });
  }
  public patchFLOA(floa: any): Observable<any> {
    const matrizz: Matriz_FLOA = {
      type: floa.tipo,
      name: floa.nombre,
      perspectiveId: Number(floa.perspectiveId),
    }
    const body = JSON.stringify(matrizz);
    const apiURL = `${this.apiURL}matriz/${floa.id}`;
    return this.http.patch(`${apiURL}`, body, { headers: this.headers });
  }
  public deleteFLOA(floa: any): Observable<any> {
    const apiURL = `${this.apiURL}matriz/${floa.id}`;
    return this.http.delete(`${apiURL}`, { headers: this.headers });
  }
}
